export default "__VITE_ASSET__CAAwMYIb__"